import { Modal } from "antd";
import dayjs from "dayjs";

/**
 * Kod 409 z products-service: klientka ma już opłacone przedłużenie tej samej
 * ceny, które jeszcze nie ruszyło (TRE-2036). To nie jest awaria, tylko pytanie
 * do operatora — dwa zamówienia z tego samego landingu potrafią wpaść minutę
 * po sobie i potwierdzenie obu doszywa dwa identyczne pakiety.
 */
export const DUPLICATE_EXTENSION_ERROR = "duplicate_extension";

export interface DuplicateExtensionRejection {
  message: string;
  /** Unix — dokąd sięga dostęp, który klientka już ma opłacony. */
  queuedUntil: number | null;
}

/** Odmowa duplikatu, czy zwykły błąd? `null` = zwykły, obsłuż jak dotąd. */
export const readDuplicateExtension = (error: unknown): DuplicateExtensionRejection | null => {
  const response = (
    error as {
      response?: { status?: number; data?: { code?: unknown; message?: unknown; data?: { queuedUntil?: unknown } } };
    }
  )?.response;

  if (response?.status !== 409 || response.data?.code !== DUPLICATE_EXTENSION_ERROR) {
    return null;
  }

  const queuedUntil = response.data?.data?.queuedUntil;

  return {
    message: typeof response.data.message === "string" ? response.data.message : "",
    queuedUntil: typeof queuedUntil === "number" ? queuedUntil : null,
  };
};

/**
 * Rzucane, gdy operator wybrał „Nie dodawaj". Nic się nie stało i nie ma o czym
 * krzyczeć — hooki rozpoznają ten typ i pomijają czerwony toast.
 */
export class DuplicateExtensionDismissed extends Error {
  constructor() {
    super("Potwierdzenie przerwane przez operatora");
    this.name = "DuplicateExtensionDismissed";
  }
}

export const isDuplicateExtensionDismissed = (error: unknown): boolean =>
  error instanceof DuplicateExtensionDismissed;

/**
 * Pyta, czy naprawdę dodać drugi taki sam pakiet.
 *
 * Domyślnym przyciskiem jest „Nie dodawaj": ta ścieżka istnieje, bo ktoś
 * kliknął dwa razy, więc odruchowy Enter ma cofać, a nie zatwierdzać.
 */
export const askAboutDuplicateExtension = ({ message, queuedUntil }: DuplicateExtensionRejection): Promise<boolean> =>
  new Promise((resolve) => {
    Modal.confirm({
      title: "Klientka ma już przedłużenie w kolejce",
      content: queuedUntil
        ? `${message} Dostęp klientki sięga dziś do ${dayjs.unix(queuedUntil).format("DD.MM.YYYY")} — potwierdzenie przedłuży go o kolejny pakiet.`
        : message,
      okText: "Dodaj mimo to",
      okButtonProps: { danger: true },
      cancelText: "Nie dodawaj",
      autoFocusButton: "cancel",
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
